<template>
  <div class="ListingFavourite text-[1.9rem]">
    <template v-if="signedIn">
      <button v-show="!liked" @click.prevent="toggleLike" class="flex items-center">
        <i class="fal fa-heart text-gray-950 hover:text-primary active:text-primary"></i>
        <slot :liked="liked" :count="listing.favourites_count"></slot>
      </button>
      <button v-show="liked" class="liked flex items-center" @click.prevent="toggleLike">
        <i class="fas fa-heart text-bt-blue-500"></i>
        <slot :liked="liked" :count="listing.favourites_count"></slot>
      </button>
    </template>

    <template v-else>
      <button @click.prevent="toggleGuestFavourite" v-show="liked" class="flex items-center">
        <i class="fas fa-heart text-bt-blue-500"></i>
        <slot :liked="liked" :count="listing.favourites_count"></slot>
      </button>
      <button @click.prevent="toggleGuestFavourite" v-show="!liked" class="text-primary flex items-center">
        <i class="fal fa-heart text-gray-950 hover:text-primary"></i>
        <slot :liked="liked" :count="listing.favourites_count"></slot>
      </button>
    </template>
  </div>
</template>

<script>
import Http from "@/lib/Http"
export default {
  name: "Listing.Favourite",
  props: {
    listing: {
      type: Object,
      required: true,
    },
    guestFavourites: {
      type: [],
      required: false,
      default: [],
    },
  },
  data() {
    return {
      liked: false,
    }
  },
  mounted() {
    this.liked = this.signedIn ? this.listing.liked : this.guestLiked
  },
  methods: {
    async toggleGuestFavourite() {
      const method = this.liked ? "DELETE" : "POST"
      const url = this.liked
        ? `api/guest_favourites/${this.listing.id}.turbo_stream`
        : "api/guest_favourites.turbo_stream"

      const response = await Http({
        method,
        url,
        params: { id: this.listing.id },
        headers: { Accept: "text/vnd.turbo-stream.html" },
      })
      Turbo.renderStreamMessage(response.data)
      this.liked = !this.liked
    },
    toggleLike() {
      const liked = this.liked
      const { favourites_count } = this.listing

      this.liked = !liked
      if (this.liked) {
        this.listing.favourites_count = favourites_count + 1
      } else {
        this.listing.favourites_count = favourites_count - 1
      }

      Http({
        method: liked ? "DELETE" : "POST",
        url: "/api/listings/favourites",
        params: { listing_id: this.listing.id },
      })
        .then(() => {
          $.getScript("/listings/favourites/navbar")
          this.favouritesCount += liked ? -1 : 1
          if (typeof ga === "function") {
            ga("send", "event", "Favourited Artwork", "website", this.listing.title)
            dataLayer.push({
              event: "addtoFavorites",
              ArtworkName: this.listing.title,
            })
          }
        })
        .catch((e) => {
          this.liked = liked
        })
    },
  },
  computed: {
    signedIn() {
      return window.config.userSignedIn
    },
    guestLiked() {
      const favourites = this.guestFavourites.map((item) => parseInt(item))
      return favourites.includes(this.listing.id)
    },
  },
  watch: {
    guestFavourites: {
      handler(newFavourites) {
        if (!this.signedIn) {
          this.liked = newFavourites.map((id) => parseInt(id)).includes(this.listing.id)
        }
      },
      immediate: true, // in case it’s already populated when mounted
    },
  },
}
</script>
